import { combineReducers } from "redux";
import dashboards from "./dashboards";
import admins from "./admins";
import categories from "./categories";
import settings from "./settings";
import posts from "./posts";
import services from "./services";
import shareholders from "./shareholders";
import languages from "./languages";
import companies from "./companies";

const rootReducer = combineReducers({
  dashboards,
  admins,
  categories,
  settings,
  posts,
  services,
  shareholders,
  languages,
  companies,
});

export default rootReducer;
